import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import { useAuthHeader } from "react-auth-kit";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useGetDoctors } from "../DoctorComponents";
import { useGetPatients } from "../PatientComponents";
import { toastError, toastSuccess } from "../../utils/utils";

// === GET /televisits
export const useGetTelevisits = () => {
  const authHeader = useAuthHeader();
  const patientsQuery = useGetPatients();

  return useQuery({
    queryKey: ["televisits"],
    queryFn: async () => {
      const res = await axiosInstance.get(`/televisits`, {
        headers: { Authorization: authHeader() },
      });
      let data = res.data;

      // operations on data
      let _televisits = [];
      for (let t of data.televisits) {
        let televisitPatient = patientsQuery.data.patients.find(
          (el) => el.id === t.patient_id
        );

        let patientInfo =
          televisitPatient === undefined
            ? ""
            : `${televisitPatient.first_name} ${televisitPatient.last_name}`;
        let doctorInfo =
          televisitPatient === undefined
            ? ""
            : `${televisitPatient.doctor.first_name} ${televisitPatient.doctor.last_name}`;

        // set doctor and patient infos back in the service object
        _televisits.push({
          ...t,
          patient_info: patientInfo,
          doctor_info: doctorInfo,
        });
      }
      data["televisits"] = _televisits;
      return data;
    },
    enabled: patientsQuery.isSuccess,
  });
};

export const useDeleteTelevisit = () => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (televisit_id) => {
      const res = await axiosInstance.delete(`/televisits/${televisit_id}`, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["patients"]);
      queryClient.invalidateQueries(["televisits"]);
      toast.success("Televisita rimossa con successo", toastSuccess);
    },
  });
};

// === GET /televisits/:televisit_id
export const useGetTelevisitById = (televisit_id) => {
  const authHeader = useAuthHeader();
  const doctorsQuery = useGetDoctors();

  return useQuery({
    queryKey: ["televisits", televisit_id],
    queryFn: async () => {
      const res = await axiosInstance.get(`/televisits/${televisit_id}`, {
        headers: { Authorization: authHeader() },
      });
      let data = res.data;

      // operations on data
      // handle colleagues list
      let tmpColleague;
      let tmpColleagueList = [];

      if (data.colleague1_id !== null) {
        tmpColleague = doctorsQuery.data.doctors.filter(
          (el) => el.id === data.colleague1_id
        )[0];
        tmpColleagueList.push(tmpColleague);
      }
      if (data.colleague2_id !== null) {
        tmpColleague = doctorsQuery.data.doctors.filter(
          (el) => el.id === data.colleague2_id
        )[0];
        tmpColleagueList.push(tmpColleague);
      }
      if (data.colleague3_id !== null) {
        tmpColleague = doctorsQuery.data.doctors.filter(
          (el) => el.id === data.colleague3_id
        )[0];
        tmpColleagueList.push(tmpColleague);
      }

      data["invitedColleagues"] = tmpColleagueList;
      return data;
    },
    enabled:
      televisit_id !== undefined &&
      televisit_id !== null &&
      doctorsQuery.isSuccess,
  });
};

// === POST /televisits
export const useNewTelevisit = (closeModal) => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newTelevisit) => {
      const res = await axiosInstance.post(`/televisits`, newTelevisit, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["televisits"]);
      queryClient.invalidateQueries(["doctors"]); // because I mutated the cache to remove myself if I was a doctor
      toast.success("Televisita aggiunta con successo!", toastSuccess);
      closeModal();
    },
    onError: (e)=> {
      toast.error("errore nell'aggiunta della televisita!", toastError);
      //closeModal();
    }
  });
};

// === PUT /televisits
export const usePutTelevisit = (televisit_id) => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();
  const getOriginalData = useGetTelevisitById(televisit_id);

  return useMutation({
    mutationFn: async (editedTelevisit) => {
      if (editedTelevisit === undefined) return;
      const res = await axiosInstance.put(
        `/televisits/${televisit_id}`,
        editedTelevisit,
        {
          headers: { Authorization: authHeader() },
        }
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["televisits"]);
      queryClient.invalidateQueries(["doctors"]); // because I mutated the cache to remove myself if I was a doctor
      toast.success("Televisita modificata con successo!", toastSuccess);
    },
    onError: (data, variables, context) => {
      queryClient.setQueryData(["televisits", televisit_id], (oldData) => {
        return {
          ...oldData,
          ...getOriginalData.data,
        };
      });
      toast.error("Dettagli televisita non aggiornati", toastError);
    },
  });
};